import React from "react";
import { Link } from "react-router-dom";

import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";

import "./ReturnToClassOverview.css";

function ReturnToAssessmentOverview(props) {
  let classDetails = props.classDetails;
  let teachers = props.teachers;
  let name = props.name;
  let gradeLevel = props.gradeLevel;
  let teacherRoles = props.teacherRoles;

  return (
    <Link
      to={`/assessmentsdashboard`}
      state={{
        classDetails: { classDetails },
        teachers: { teachers },
        name: { name },
        gradeLevel: { gradeLevel },
        teacherRoles: { teacherRoles },
      }}
    >
      <img
        src={process.env.PUBLIC_URL + "/assets/imgs/arrow-left.svg"}
        alt="Back"
        className="back-arrow"
        style={{ cursor: "pointer" }}
      />
    </Link>
  );
}

export default ReturnToAssessmentOverview;
